<main class="table-page table-page--fill table-page--scroll" dir="rtl">
  <header class="header">
    <div class="title-row">
      <button class="back" type="button" routerLink="/" aria-label="بازگشت"><i class="fa fa-arrow-right" aria-hidden="true"></i></button>
      <div class="title-block"><h1 class="title">پیش ثبت‌نام تانکر</h1></div>
      <div class="actions">
        <button class="btn btn-ghost" type="button" (click)="showFilter = !showFilter" [attr.aria-expanded]="showFilter" aria-controls="tankerFilters">
          <i class="fa fa-sliders" aria-hidden="true"></i> فیلتر <i class="fa fa-chevron-down chev" aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <div class="collapsible" id="tankerFilters" [class.collapsed]="!showFilter">
      <div class="collapsible-inner">
        <form class="filters" [formGroup]="mdl_Search" (ngSubmit)="getList()">
          <div class="field"><label class="field-label" for="strSInstallDate">تاریخ نصب از</label>
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'" [dateInitValue]="false" [dateFormat]="'jYYYY/jMM/jDD'"><input id="strSInstallDate" type="text" class="control" formControlName="strSInstallDate" /></ng-persian-datepicker>
          </div>
          <div class="field"><label class="field-label" for="strEInstallDate">تا تاریخ نصب</label>
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'" [dateInitValue]="false" [dateFormat]="'jYYYY/jMM/jDD'"><input id="strEInstallDate" type="text" class="control" formControlName="strEInstallDate" /></ng-persian-datepicker>
          </div>
          <div class="field"><label class="field-label" for="strSRegisterDate">تاریخ ثبت نام از</label>
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'" [dateInitValue]="false" [dateFormat]="'jYYYY/jMM/jDD'"><input id="strSRegisterDate" type="text" class="control" formControlName="strSRegisterDate" /></ng-persian-datepicker>
          </div>
          <div class="field"><label class="field-label" for="strERegisterDate">تا تاریخ ثبت نام</label>
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'" [dateInitValue]="false" [dateFormat]="'jYYYY/jMM/jDD'"><input id="strERegisterDate" type="text" class="control" formControlName="strERegisterDate" /></ng-persian-datepicker>
          </div>
          <div class="field"><label class="field-label" for="strState">استان</label>
            <select id="strState" class="control" formControlName="strState" (change)="getCity($event.target.value)"><option value="">انتخاب کنید</option><option *ngFor="let item of lst_State" [value]="item.strState">{{ item.strStateName }}</option></select>
          </div>
          <div class="field" *ngIf="mdl_Search.get('strState')?.value != ''"><label class="field-label" for="strCity">شهر</label>
            <select id="strCity" class="control" formControlName="strCity"><option value="">انتخاب کنید</option><option *ngFor="let item of lst_City" [value]="item.strCity">{{ item.strCityName }}</option></select>
          </div>
          <div class="field"><label class="field-label" for="tiInstallationStatus">وضعیت</label>
            <select id="tiInstallationStatus" class="control" formControlName="tiInstallationStatus"><option value="-1">انتخاب کنید</option><option *ngFor="let item of lst_Installation_Status" [value]="item.tiInstallationStatus">{{ item.strInstallationStatus }}</option></select>
          </div>
          <div class="field"><label class="field-label" for="iInstaller">نصاب</label>
            <select id="iInstaller" class="control" formControlName="iInstaller"><option value="-1">انتخاب کنید</option><option *ngFor="let item of lst_Installer" [value]="item.iInstaller">{{ item.strFullName }}</option></select>
          </div>
          <div class="field"><label class="field-label" for="iSystemUser_Visitor">بازاریاب</label>
            <select id="iSystemUser_Visitor" class="control" formControlName="iSystemUser_Visitor"><option value="-1">انتخاب کنید</option><option *ngFor="let item of lst_Visitor" [value]="item.iSystemUser">{{ item.strFullName }}</option></select>
          </div>
          <div class="field"><label class="field-label" for="strMobile">موبایل</label><input id="strMobile" type="text" class="control" formControlName="strMobile" /></div>
          <div class="filter-actions"><button class="btn btn-primary" type="submit"><i class="fa fa-search" aria-hidden="true"></i> جستجو</button></div>
        </form>
      </div>
    </div>
  </header>
  <section class="card" aria-label="فهرست پیش ثبت‌نام تانکر">
    <div class="table-toolbar">
      <div class="search-wrap"><input class="control" type="search" aria-label="جستجو در جدول" placeholder="جستجو در جدول..." [(ngModel)]="searchText" (input)="filter_Result($event.target)" /><i class="fa fa-search" aria-hidden="true"></i></div>
      <div class="toolbar-actions">
        <div class="btn-group">
          <button type="button" class="btn btn-ghost dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">عملیات‌ها</button>
          <div class="dropdown-menu prototype-menu" dir="rtl">
            <button type="button" class="dd-item" (click)="setSchedule()"><i class="fa fa-calendar" aria-hidden="true"></i>تعیین زمان نصب</button>
            <button type="button" class="dd-item" (click)="chooseInstaller()"><i class="fa fa-user" aria-hidden="true"></i>تعیین نصاب</button>
            <button type="button" class="dd-item" (click)="open_UpdateStatus()"><i class="fa fa-refresh" aria-hidden="true"></i>تغییر وضعیت</button>
            <div class="dd-sep" role="separator"></div>
            <button type="button" class="dd-item" (click)="open_Send_SMS()"><i class="fa fa-comment-o" aria-hidden="true"></i>پیامک به متقاضی</button>
            <button type="button" class="dd-item" (click)="open_Send_SMSInstaller()"><i class="fa fa-comment-o" aria-hidden="true"></i>پیامک به نصاب</button>
            <button type="button" class="dd-item" (click)="sendPaymentLink()"><i class="fa fa-link" aria-hidden="true"></i>پیامک لینک پرداخت</button>
          </div>
        </div>
        <button class="btn btn-soft" type="button" (click)="showCluster()"><i class="fa fa-map-marker" aria-hidden="true"></i> محل‌های نصب</button>
        <button class="btn btn-soft" type="button" (click)="exportexcel('Export_Excel')"><i class="fa fa-file-excel-o" aria-hidden="true"></i> خروجی اکسل</button>
      </div>
    </div>
    <div class="body">
      <div class="state" [class.show]="!lst_Result.length"><div class="ico-big"><i class="fa fa-inbox" aria-hidden="true"></i></div><h4>نتیجه‌ای پیدا نشد</h4><span class="muted">فیلترها را بررسی و دوباره جستجو کنید.</span></div>
      <div class="table-scroll" *ngIf="lst_Result.length">
        <ng-container [ngTemplateOutlet]="recordsTable" [ngTemplateOutletContext]="{ data: lst_Result | slice:(currentPage - 1) * pageSize:currentPage * pageSize, offset: (currentPage - 1) * pageSize, exporting: false }"></ng-container>
      </div>
    </div>
    <app-table-pagination [page]="currentPage" [pageSize]="pageSize" [totalItems]="lst_Result.length" (pageChange)="currentPage = $event" (pageSizeChange)="pageSize = $event; currentPage = 1"></app-table-pagination>
  </section>
  <div hidden><ng-container [ngTemplateOutlet]="recordsTable" [ngTemplateOutletContext]="{ data: lst_Result, offset: 0, exporting: true }"></ng-container></div>
  <ng-template #recordsTable let-data="data" let-offset="offset" let-exporting="exporting">
    <table [id]="exporting ? 'Export_Excel' : null">
      <thead><tr>
        <th *ngIf="!exporting" class="col-ops sticky-first">عملیات</th><th class="col-num">ردیف</th>
        <th *ngIf="!exporting"><input type="checkbox" aria-label="انتخاب همه نتایج" [checked]="allResultsSelected" (change)="selectAllCheckBox()" /></th>
        <th>وضعیت</th><th>استان</th><th>شهر</th><th>نام و نام خانوادگی</th><th>موبایل</th><th>تاریخ ثبت نام</th><th>تاریخ اعلامی</th><th>تاریخ نصب</th><th>نصاب</th><th>شماره پیگیری پرداخت</th><th>بازاریاب</th>
      </tr></thead>
      <tbody><tr *ngFor="let item of data; let i = index">
        <td *ngIf="!exporting" class="col-ops sticky-first"><div class="row-ops">
          <button class="ico" type="button" aria-label="مشاهده اطلاعات" title="مشاهده اطلاعات" (click)="open_Info(item, offset + i)"><i class="fa fa-info-circle" aria-hidden="true"></i></button>
          <button *ngIf="accessibility('bFleetYar_Advance_PreregistrationEdit')" class="ico" type="button" aria-label="ویرایش" title="ویرایش" (click)="open_Edit(item, offset + i)"><i class="fa fa-pencil" aria-hidden="true"></i></button>
        </div></td>
        <td class="col-num">{{ offset + i + 1 | faNum }}</td>
        <td *ngIf="!exporting"><input type="checkbox" [attr.aria-label]="'انتخاب ' + item.strName + ' ' + item.strFamily" (change)="setCheckBox($event.target.checked, item)" [checked]="isSelected(item.iPreregistration)" /></td>
        <td>{{ item.strInstallationStatus | faNum }}</td><td>{{ item.strStateName | faNum }}</td><td>{{ item.strCityName | faNum }}</td><td>{{ item.strName + ' ' + item.strFamily | faNum }}</td><td class="num">{{ item.strMobile | faNum }}</td><td class="num">{{ item?.strRegisterDateTime | faNum }}</td><td class="num">{{ item?.strAnnouncementTime | faNum }}</td><td class="num">{{ item?.strInstallDate | faNum }}</td><td>{{ item?.strFullName }}</td><td class="num">{{ item?.iTrackingCode | faNum }}</td><td>{{ item?.strSystemUser_strFullName }}</td>
      </tr></tbody>
    </table>
  </ng-template>

    <!-- تعیین زمان نصب -->

    <div class="modal fade" id="schedule_Modal">

        <div class="modal-dialog">

            <div class="modal-content dirI">

                <div class="modal-header dirI">

                    <h5 class="modal-title" id="exampleModalLabel"> تعیین زمان نصب </h5>

                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

                </div>

                <div class="modal-body">

                    <div [formGroup]="mdl_Schedule" class="container-fluid row gx-2 gy-2 p-2">

                        <!-- تاریخ -->

                        <div class="col-12 col-md-6 position-relative">

                            <label style="top: -8px;"> تاریخ </label>

                            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                                [dateGregorianFormat]="'YYYY/MM/DD'" [dateInitValue]="true"
                                [dateFormat]="'jYYYY/jMM/jDD'">

                                <input formControlName="strInstallDate" class="form-control text-end" />

                            </ng-persian-datepicker>

                        </div>

                        <!-- ساعت -->

                        <div class="col-12 col-md-6 clockpicker position-relative">

                            <label style="top: -8px;"> ساعت </label>

                            <input id="strInstallTime" formControlName="strInstallTime"
                                class="form-control text-center">

                        </div>

                    </div>

                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-ghost" data-bs-dismiss="modal">بستن</button>
                    <button type="button" class="btn btn-primary" (click)="submit_Schedule()">ثبت اطلاعات</button>
                </div>

            </div>

        </div>

    </div>

    <!-- تعیین نصاب -->

    <div class="modal fade" id="installer_Modal">

        <div class="modal-dialog">

            <div class="modal-content dirI">

                <div class="modal-header dirI">

                    <h5 class="modal-title" id="exampleModalLabel"> تعیین نصاب </h5>

                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

                </div>

                <div class="modal-body">

                    <div [formGroup]="mdl_Select_Installer" class="container-fluid row gx-2 gy-2 p-2">

                        <!-- نصاب -->

                        <div class="col-12">

                            <div class="position-relative w-100 h-100">

                                <label style="top: -8px;z-index: 2;z-index: 10000;"> نصاب </label>

                                <ng-select class="ng-select" [items]="lst_Installer" bindLabel="strFullName"
                                    bindValue="iInstaller" [clearable]="true" [placeholder]="'جستجو کنید ...'"
                                    [notFoundText]="'موردی یافت نشد'" formControlName="iInstaller">

                                    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">

                                        <div *ngFor="let item of items | slice:0:1" class="ng-value">

                                            <span class="ng-value-label">{{ item.strFullName }}</span>

                                            <span class="ng-value-icon right" (click)="clear(item)"
                                                aria-hidden="true">×</span>

                                        </div>

                                        <div *ngIf="items.length > 1" class="ng-value">

                                            <span class="ng-value-label"> {{ items.length - 1 | faNum }}+ مورد </span>

                                        </div>

                                    </ng-template>

                                </ng-select>

                            </div>

                        </div>

                    </div>

                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-ghost" data-bs-dismiss="modal">بستن</button>
                    <button type="button" class="btn btn-primary" (click)="submit_Installer()">ثبت اطلاعات</button>
                </div>

            </div>

        </div>

    </div>

    <!-- تغییر وضعیت -->

    <div class="modal fade" id="status_Modal">

        <div class="modal-dialog">

            <div class="modal-content dirI">

                <div class="modal-header dirI">

                    <h5 class="modal-title" id="exampleModalLabel"> تغییر وضعیت </h5>

                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

                </div>

                <div class="modal-body">

                    <div [formGroup]="mdl_Status" class="container-fluid row gx-2 gy-2 p-2">

                        <!-- وضعیت -->

                        <div class="col-12">

                            <div class="position-relative w-100 h-100">

                                <label style="top: -8px;z-index: 2;z-index: 10000;"> وضعیت </label>

                                <ng-select class="custom" [items]="lst_Status" bindLabel="strInstallationStatus"
                                    bindValue="tiInstallationStatus" [clearable]="true" [placeholder]="'جستجو کنید ...'"
                                    [notFoundText]="'موردی یافت نشد'" formControlName="tiInstallationStatus">

                                    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">

                                        <div *ngFor="let item of items | slice:0:1" class="ng-value">

                                            <span class="ng-value-label">{{ item.strInstallationStatus }}</span>

                                            <span class="ng-value-icon right" (click)="clear(item)"
                                                aria-hidden="true">×</span>

                                        </div>

                                        <div *ngIf="items.length > 1" class="ng-value">

                                            <span class="ng-value-label"> {{ items.length - 1 | faNum }}+ مورد </span>

                                        </div>

                                    </ng-template>

                                </ng-select>

                            </div>

                        </div>

                    </div>

                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-ghost" data-bs-dismiss="modal">بستن</button>
                    <button type="button" class="btn btn-primary" (click)="submit_Status()">ثبت اطلاعات</button>
                </div>

            </div>

        </div>

    </div>

    <!-- پیامک به متقاضی -->

    <div class="modal fade" id="sendSms_Modal">

        <div class="modal-dialog">

            <div class="modal-content dirI">

                <div class="modal-header dirI">

                    <h5 class="modal-title" id="exampleModalLabel"> پیامک به متقاضی </h5>

                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

                </div>

                <div class="modal-body">

                    <div [formGroup]="mdl_SMS" class="container-fluid row gx-2 gy-2 p-2">

                        <!-- متن پیامک -->

                        <div class="col-12">

                            <div class="position-relative w-100 h-100 p-2">

                                <label class="mb-2 text-muted"> متن پیامک </label>

                                <textarea style="height: 100px;resize: none;" formControlName="strSMS"
                                    class="form-control"></textarea>

                            </div>

                        </div>

                    </div>

                </div>

                <div class="modal-footer d-flex justify-content-start">

                    <button class="btn btn-success" (click)="submit_Sms()">

                        ثبت اطلاعات

                    </button>

                    <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                        &nbsp; بستن &nbsp;

                    </button>

                </div>

            </div>

        </div>

    </div>

    <!-- پیامک به نصاب -->

    <div class="modal fade" id="sendSmsInstaller_Modal">

        <div class="modal-dialog">

            <div class="modal-content dirI">

                <div class="modal-header dirI">

                    <h5 class="modal-title" id="exampleModalLabel"> پیامک به نصاب </h5>

                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

                </div>

                <div class="modal-body">

                    <div [formGroup]="mdl_SMS_Installer" class="container-fluid row gx-2 gy-2 p-2">

                        <!-- متن پیامک -->

                        <div class="col-12">

                            <div class="position-relative w-100 h-100 p-2">

                                <label class="mb-2 text-muted"> متن پیامک </label>

                                <textarea style="height: 100px;resize: none;" formControlName="strSMS"
                                    class="form-control"></textarea>

                            </div>

                        </div>

                    </div>

                </div>

                <div class="modal-footer d-flex justify-content-start">

                    <button class="btn btn-success" (click)="submit_SmsInstaller()">

                        ثبت اطلاعات

                    </button>

                    <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                        &nbsp; بستن &nbsp;

                    </button>

                </div>

            </div>

        </div>

    </div>

    <!-- جزئیات درخواست -->

    <div class="modal fade" id="requestInfo_Modal" style="z-index:1054">

        <div class="modal-dialog modal-lg">

            <div class="modal-content dirI">

                <div class="modal-header dirI">

                    <h5 class="modal-title" id="exampleModalLabel"> جزئیات درخواست </h5>

                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

                </div>

                <div class="modal-body">

                    <div [formGroup]="mdl_Request" class="container-fluid row gx-2 gy-3 p-2">

                        <!-- نام و نام خانوادگی -->

                        <div class="col-12 col-md-4 position-relative">

                            <label style="top: -8px;"> نام و نام خانوادگی </label>

                            <input formControlName="strFamily" class="form-control text-center">

                        </div>

                        <!-- موبایل -->

                        <div class="col-12 col-md-4 position-relative">

                            <label style="top: -8px;"> موبایل </label>

                            <input formControlName="strMobile" class="form-control text-center">

                        </div>

                        <!-- کد ملی -->

                        <div class="col-12 col-md-4 position-relative">

                            <label style="top: -8px;"> کد ملی </label>

                            <input formControlName="strID" class="form-control text-center">

                        </div>

                        <!-- استان -->

                        <div class="col-12 col-md-4 position-relative">

                            <label style="top: -8px;"> استان </label>

                            <input formControlName="strStateName" class="form-control text-center">

                        </div>

                        <!-- شهر -->

                        <div class="col-12 col-md-4 position-relative">

                            <label style="top: -8px;"> شهر </label>

                            <input formControlName="strCityName" class="form-control text-center">

                        </div>

                        <!-- نصاب -->

                        <div class="col-12 col-md-4 position-relative">

                            <label style="top: -8px;"> نصاب </label>

                            <input formControlName="strInstaller_strFullName" class="form-control text-center">

                        </div>

                        <!-- موبایل نصاب -->

                        <div class="col-12 col-md-4 position-relative">

                            <label style="top: -8px;"> موبایل نصاب </label>

                            <input formControlName="strMobile1" class="form-control text-center">

                        </div>

                        <!-- نوع تانکر -->

                        <div class="col-12 col-md-4 position-relative">

                            <label style="top: -8px;"> نوع تانکر </label>

                            <input formControlName="strGPSType" class="form-control text-center">

                        </div>

                        <!-- شماره مجوز -->

                        <div class="col-12 col-md-4 position-relative">

                            <label style="top: -8px;"> شماره مجوز </label>

                            <input formControlName="strLicenseNo" class="form-control text-center">

                        </div>

                        <!-- وضعیت -->

                        <div class="col-12 col-md-4 position-relative">

                            <label style="top: -8px;"> وضعیت </label>

                            <input formControlName="strInstallationStatus" class="form-control text-center">

                        </div>

                        <!-- شماره پیگیری پرداخت  -->

                        <ng-container *ngIf="mdl_Request.get('iTrackingCode')?.value > 0">

                            <div class="col-12 col-md-4 position-relative">

                                <label style="top: -8px;"> شماره پیگیری پرداخت </label>

                                <input formControlName="iTrackingCode" class="form-control text-center">

                            </div>

                        </ng-container>

                        <!-- توضیحات -->

                        <div class="col-12 position-relative">

                            <label style="top: -8px;"> توضیحات </label>

                            <textarea style="min-height: 100px;resize: none;" formControlName="strComment"
                                class="form-control"></textarea>

                        </div>

                        <!-- توضیحات نصاب -->

                        <div class="col-12 position-relative">

                            <label style="top: -8px;"> توضیحات نصاب </label>

                            <textarea style="min-height: 100px;resize: none;" formControlName="strInstallerComment"
                                class="form-control"></textarea>

                        </div>

                    </div>

                    <div class="container-fluid row gx-2 gy-2 p-2">
                        <div class="col-12 col-sm-6 col-lg-auto">
                            <button type="button" class="btn btn-soft w-100" (click)="open_UpdateStatus()"><i class="fa fa-refresh" aria-hidden="true"></i> تغییر وضعیت</button>
                        </div>
                        <div class="col-12 col-sm-6 col-lg-auto">
                            <button type="button" class="btn btn-soft w-100" (click)="setSchedule()"><i class="fa fa-calendar" aria-hidden="true"></i> تعیین زمان نصب</button>
                        </div>
                        <div class="col-12 col-sm-6 col-lg-auto">
                            <button type="button" class="btn btn-soft w-100" (click)="chooseInstaller()"><i class="fa fa-user" aria-hidden="true"></i> تعیین نصاب</button>
                        </div>
                        <div class="col-12 col-sm-6 col-lg-auto">
                            <div class="btn-group w-100">
                                <button type="button" class="btn btn-ghost dropdown-toggle w-100" data-bs-toggle="dropdown" aria-expanded="false">اقدامات بیشتر</button>
                                <div class="dropdown-menu prototype-menu" dir="rtl">
                                    <button type="button" class="dd-item" (click)="open_Send_SMS()"><i class="fa fa-comment-o" aria-hidden="true"></i> پیامک به متقاضی</button>
                                    <button type="button" class="dd-item" (click)="open_Send_SMSInstaller()"><i class="fa fa-comment-o" aria-hidden="true"></i> پیامک به نصاب</button>
                                    <button *ngIf="mdl_Request.get('strLicenseImage')?.value" type="button" class="dd-item" (click)="viewFullScreen()"><i class="fa fa-picture-o" aria-hidden="true"></i> نمایش تصویر مجوز</button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="modal-footer d-flex justify-content-start">

                    <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                        &nbsp; بستن &nbsp;

                    </button>

                </div>

            </div>

        </div>

    </div>

    <!-- ویرایش درخواست -->

    <div class="modal fade" id="editRequest_Modal" style="z-index:1054">

        <div class="modal-dialog modal-lg">

            <div class="modal-content dirI">

                <div class="modal-header dirI">

                    <h5 class="modal-title" id="exampleModalLabel"> ویرایش درخواست </h5>

                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

                </div>

                <div class="modal-body">

                    <div [formGroup]="mdl_Request" class="container-fluid row gx-2 gy-3 p-2">

                        <!-- اطلاعات تکمیلی -->

                        <ng-container *ngIf="false">

                            <!-- نام و نام خانوادگی -->

                            <div class="col-12 col-md-4 position-relative">

                                <label style="top: -8px;"> نام و نام خانوادگی </label>

                                <input formControlName="strFamily" class="form-control text-center">

                            </div>

                            <!-- موبایل -->

                            <div class="col-12 col-md-4 position-relative">

                                <label style="top: -8px;"> موبایل </label>

                                <input formControlName="strMobile" class="form-control text-center">

                            </div>

                            <!-- کد ملی -->

                            <div class="col-12 col-md-4 position-relative">

                                <label style="top: -8px;"> کد ملی </label>

                                <input formControlName="strID" class="form-control text-center">

                            </div>

                            <!-- نصاب -->

                            <div class="col-12 col-md-4 position-relative">

                                <label style="top: -8px;"> نصاب </label>

                                <input formControlName="strInstaller_strFullName" class="form-control text-center">

                            </div>

                            <!-- موبایل نصاب -->

                            <div class="col-12 col-md-4 position-relative">

                                <label style="top: -8px;"> موبایل نصاب </label>

                                <input formControlName="strMobile1" class="form-control text-center">

                            </div>

                            <!-- نوع شناور -->

                            <div class="col-12 col-md-4 position-relative">

                                <label style="top: -8px;"> نوع شناور </label>

                                <input formControlName="strFloatingType" class="form-control text-center">

                            </div>

                            <!-- شماره پروانه صیادی -->

                            <div class="col-12 col-md-4 position-relative">

                                <label style="top: -8px;"> شماره پروانه صیادی </label>

                                <input formControlName="strLicenseNo" class="form-control text-center">

                            </div>

                            <!-- شماره پیگیری پرداخت  -->
    
                            <ng-container *ngIf="mdl_Request.get('iTrackingCode')?.value > 0">
    
                                <div class="col-12 col-md-4 position-relative">
    
                                    <label style="top: -8px;"> شماره پیگیری پرداخت </label>
    
                                    <input formControlName="iTrackingCode" class="form-control text-center">
    
                                </div>
    
                            </ng-container>
    
                            <!-- توضیحات نصاب -->
    
                            <ng-container *ngIf="mdl_Request.get('strInstallerComment')?.value">
    
                                <div class="col-12 position-relative">
        
                                    <label style="top: -8px;"> توضیحات نصاب </label>
        
                                    <textarea style="min-height: 100px;resize: none;" formControlName="strInstallerComment"
                                        class="form-control"></textarea>
        
                                </div>
    
                            </ng-container>
    
                            <!-- divider -->
    
                            <div class="col-12 p-2">
    
                                <div class="w-100 border-bottom"></div>
    
                            </div>

                        </ng-container>

                        <!-- استان -->

                        <div class="col-12 col-md-4 position-relative">

                            <label style="top: -8px;"> استان </label>

                            <select class="form-select p-2" formControlName="strState"
                                (change)="getCity($event.target.value)">

                                <option class="text-center" value=""> انتخاب کنید </option>

                                <option *ngFor="let s of lst_State" [value]="s.strState" class="text-center">

                                    {{ s.strStateName }}

                                </option>

                            </select>

                        </div>

                        <!-- شهر -->

                        <div class="col-12 col-md-4 position-relative">

                            <label style="top: -8px;"> شهر </label>

                            <select class="form-select p-2" formControlName="strCity">

                                <option class="text-center" value=""> انتخاب کنید </option>

                                <option *ngFor="let c of lst_City" [value]="c.strCity" class="text-center">

                                    {{ c.strCityName }}

                                </option>

                            </select>

                        </div>

                        <!-- وضعیت -->

                        <div class="col-12 col-md-4 position-relative">

                            <label style="top: -8px;"> وضعیت </label>

                            <select class="form-select p-2" formControlName="tiInstallationStatus">

                                <option *ngFor="let Is of lst_Installation_Status" [value]="Is.tiInstallationStatus" class="text-center">

                                    {{ Is.strInstallationStatus }}

                                </option>

                            </select>

                        </div>

                        <!-- آدرس -->

                        <div class="position-relative col-12 p-2">

                            <label class="mb-2 text-muted"> آدرس </label>

                            <custom-map *ngIf="bMapInput"

                                [strValue]="mdl_Request.get('strAddress')?.value"

                                [longLat]="[mdl_Request.get('fLon')?.value,mdl_Request.get('fLat')?.value]"
                            
                                [stylesArray]="['padding-top: 10px']"

                                [isTextArea]="false"

                                [isLocationBtn]="true"
                            
                                [str_Placeholder]="'آدرس خود را جستجو کنید ...'"
                                
                                (mdl_Submit)="submitData($event)">

                            </custom-map>

                        </div>

                        <!-- پلاک خودرو -->

                        <div class="position-relative col-12 p-2">

                            <div class="vehicle-no-field-wrapper">

                            <label for="strVehicleNo">پلاک خودرو</label>

                            <div class="vehicle-no-field mb-2 p-1" id="strVehicleNo">

                                <input type="text" maxlength="2" inputmode="numeric" class="border-left"

                                    formControlName="plak4" placeholder="- -" (keydown)="onlyNumber($event)">

                                <input type="text" maxlength="3" inputmode="numeric" formControlName="plak3"

                                    placeholder="- - -" (keydown)="onlyNumber($event)">

                                <input type="text" maxlength="1" formControlName="plak2" placeholder="-"

                                    (keydown)="onlyPersian($event)" (input)="sanitizePersian($event)">

                                <input type="text" maxlength="2" inputmode="numeric" formControlName="plak1"

                                    placeholder="- -" (keydown)="onlyNumber($event)">

                                <span><img src="../../../assets/Img/iran-flag-dark.svg"></span>

                            </div>
                            
                        </div>
                        
                        </div>

                        <!-- توضیحات -->

                        <div class="col-12 position-relative">

                            <label style="top: -8px;"> توضیحات </label>

                            <textarea style="min-height: 100px;resize: none;" formControlName="strComment"
                                class="form-control"></textarea>

                        </div>

                    </div>

                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-ghost" data-bs-dismiss="modal">بستن</button>
                    <button type="button" class="btn btn-primary" (click)="updateRequest()">اعمال تغییرات</button>
                </div>

            </div>

        </div>

    </div>

</main>